<template>
  <div class="order-wrapper" v-if="!isLoading">
    <portal target-el="#filter">
      <Breadcrumb
        back="Invoice"
        title="Wallet"
      />
    </portal>
    <Header />
    <Row v-for="wallet in walletList" v-bind:key="wallet.transporter_id" :wallet="wallet" />
  </div>
</template>


<script>
import Header from './header';
import Row from './row';
import Breadcrumb from '../common/breadcrumb';
import { mapGetters } from 'vuex';

export default {
  components: {
    Breadcrumb,
    Header,
    Row,
  },

  computed: {
    ...mapGetters({
      isLoading: 'wallet/isLoading',
      walletList: 'wallet/list',
    }),
  },

  async created() {
    await this.$store.dispatch('wallet/list');
  },

};
</script>
